import { render, staticRenderFns } from "./iRechargePerks.vue?vue&type=template&id=2a26ce70&scoped=true&"
import script from "./iRechargePerks.vue?vue&type=script&lang=js&"
export * from "./iRechargePerks.vue?vue&type=script&lang=js&"
import style0 from "./iRechargePerks.vue?vue&type=style&index=0&id=2a26ce70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a26ce70",
  null
  
)

export default component.exports